import styled from 'styled-components';

export const DropdownLabel = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rhino);
  margin-bottom: 4px;
`;
